import {Constants} from './groupConstants'
import {Group, GroupMember} from '../../../model/group.model'

export function addGroup(group: Group) {
	return {
		type: Constants.ADD_GROUP,
		payload: group
	} as const
}

export function updateGroup(group: Group) {
	return {
		type: Constants.UPDATE_GROUP,
		payload: group
	} as const
}

export function removeGroup(groupId: number) {
	return {
		type: Constants.REMOVE_GROUP,
		payload: groupId
	} as const
}

export function addGroupMember(groupId: number, groupMember: GroupMember) {
	return {
		type: Constants.ADD_GROUP_MEMBER,
		payload: {groupId: groupId, groupMember: groupMember}
	} as const
}

export function updateGroupMember(groupId: number, groupMember: GroupMember) {
	return {
		type: Constants.UPDATE_GROUP_MEMBER,
		payload: {groupId: groupId, groupMember: groupMember}
	} as const
}

export function removeGroupMember(groupId: number, memberId: number) {
	return {
		type: Constants.REMOVE_GROUP_MEMBER,
		payload: {groupId: groupId, memberId: memberId}
	} as const
}

